import React, { useState, useEffect, useRef } from "react";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import api from "services/api";
import { Accordion } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

function Faqs(props) {
  const history = useHistory();
  const [faqs, setFaqs] = useState([]);
  const getFaqs = async () => {
    props.setSpinner(true);
    var response = await api.get("/get-faqs");
    props.setSpinner(false);
    if (response.status === 200) {
      setFaqs(response.data);
    }
  };
  useEffect(() => {
    getFaqs();
  }, []);
  const accordionToggled = (lastOpenItem) => {
    if (lastOpenItem !== null) {
      lastOpenItem = parseInt(lastOpenItem);
    }
  };
  return (
    <>
      <div className="access_control_area faq-container">
        <img
          alt=""
          className="faq-bg"
          src={require("assets/winnabull/images/common/glow-light-min.png")}
        />
        {props.heading && (
          <h3 className="faq-main-heading">
            {__("Frequently asked questions.")}
          </h3>
        )}

        <div className="faq-area">
          {faqs.map((faqCategory, index) => (
            <>
              <div className="faq-items">
                <div className="faq-heading">{faqCategory.category}</div>

                <Accordion className="childFaq">
                  {faqCategory.faqs.map((faq, index2) => (
                    <Accordion.Item
                      key={index2}
                      eventKey={index2}
                      className="faq-item chimp-accordion"
                    >
                      <Accordion.Header className={"faq__question"}>
                        {faq.title}
                      </Accordion.Header>
                      <Accordion.Body className="faq__answer">
                        {faq.description}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </>
          ))}
          <div className="clearfix"></div>
        </div>
      </div>
    </>
  );
}

export default Faqs;
